import { DATA_SELECTOR_INJECTION_TOKEN } from '@aiwyn/shared';
import { AfterViewInit, Component, inject, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { defer, Subject } from 'rxjs';
import { shareReplay, switchMap, take, takeUntil, tap } from 'rxjs/operators';

import { ClientRequestDocumentUploadModel, RequestSection } from '@aiwyn/api';
import { BaseCommonClientRequest } from '@aiwyn/common/client-requests';
import { LaunchDarklyFlag, LaunchDarklyService } from '@aiwyn/config';

@Component({
  selector: 'awn-client-request-navigation-tab',
  templateUrl: './navigation-tab.component.html',
  styleUrl: './navigation-tab.component.scss',
  providers: [
    {
      provide: DATA_SELECTOR_INJECTION_TOKEN,
      useValue: 'navigation-tab',
    },
  ],
  standalone: false,
})
export class ClientRequestNavigationTabComponent implements AfterViewInit, OnDestroy {
  @Input() instance!: BaseCommonClientRequest<ClientRequestDocumentUploadModel>;
  public dataSelector = inject(DATA_SELECTOR_INJECTION_TOKEN);

  private readonly destroy$ = new Subject<void>();

  sections$ = defer(() => this.instance.typeClass$).pipe(
    switchMap((typeClass) => typeClass.sections$),
    shareReplay(1),
  );

  expandedSections: Record<number, boolean> = {};

  protected enableReferenceId$ = inject(LaunchDarklyService).getFeatureFlag(LaunchDarklyFlag.ENABLE_REFERENCE_ID);

  constructor(
    protected router: Router,
    protected store: Store,
    protected route: ActivatedRoute,
  ) {}

  ngAfterViewInit(): void {
    this.sections$
      .pipe(
        take(1),
        tap((sections) => {
          sections.forEach((section) => {
            this.expandedSections[section.id] = true;
          });
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }

  expandSection(section: RequestSection): void {
    this.expandedSections[section.id] = !this.expandedSections[section.id];
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
